import dayjs from 'dayjs'
import { db } from '../db/db'
import { ExtractlyPlusFile, GetFileType, TestDataOcr } from '../types'
import utc from 'dayjs/plugin/utc'
import { breakDownOcr } from './ocr'
import { getDateBlocks } from './fuzzy'
dayjs.extend(utc)

export const addFileToDB = (file: ExtractlyPlusFile) => db.files.put(file)

export const fileInDB = (fileId: string) =>
  db.files.where({ id: fileId }).count()

export const getFileFromDB = (fileId: string) => db.files.get(fileId)

export const getFilesFromDB = (fileIds: string[]) =>
  db.files.where('id').anyOf(fileIds).toArray()

export const removeFileFromDB = (fileId: string) => db.files.delete(fileId)

export const revalidateFiles = async (day: number) => {
  const sevenDaysAgoDayjs = dayjs.utc().subtract(day, 'day') // dayjs object in UTC
  const sevenDaysAgoDate = sevenDaysAgoDayjs.toDate()
  const toBeDeletedKeys = await db.files
    .where('createdAt')
    .below(sevenDaysAgoDate)
    .primaryKeys()
  if (toBeDeletedKeys.length) await db.files.bulkDelete(toBeDeletedKeys)
}

export const cacheFile = async (data: GetFileType) => {
  const pdf = await (await fetch(data.pdfUrl)).blob()
  const ocr: TestDataOcr = await (await fetch(data.ocrUrl)).json()
  const [, , , lines, words] = breakDownOcr(ocr, 0)
  const blocks = [...lines.values(), ...words.values()]
  const dateBlocks = getDateBlocks(blocks)
  const extractlyPlusFile: ExtractlyPlusFile = {
    id: data.fileId,
    createdAt: new Date(),
    fileName: data.fileName,
    type: data.type,
    folderName: data.folderName,
    parentFolderId: data.parentFolderId,
    dir: data.dir,
    ocr,
    pdf,
    ocrDateCache: dateBlocks,
    extractionMethod: data.extractionMethod,
    isLocal: false,
  }
  await addFileToDB(extractlyPlusFile)
  return extractlyPlusFile
}
